import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://ahobilam.com';
const API = BACKEND_URL.endsWith('/api') ? BACKEND_URL : `${BACKEND_URL}/api`;

const POPULAR_SEARCHES = [
  { en: 'Upakarma (Avani Avittam)', ta: 'உபாகர்மா (ஆவணி அவிட்டம்)', query: 'உபாகர்மா', url: '/vaidhikam/prayogams' },
  { en: 'Bodhayana Sutram & Upakarma', ta: 'போதாயன உபாகர்மா & அமாவாசை', query: 'போதாயன', url: '/qa?q=போதாயன' },
  { en: 'Karmangalin Thathuvangal', ta: 'கர்மங்களின் தத்துவங்கள்', query: 'கர்மங்களின் தத்துவங்கள்', url: '/karmangalin-thathuvangal' },
  { en: '108 Divyadesams', ta: '108 திவ்யதேசங்கள்', query: 'திவ்யதேசம்', url: '/divyadesams' },
  { en: 'Asoucham / Theetu', ta: 'ஜனன மரண தீட்டு', query: 'தீட்டு', url: '/vaideekam/asoucham' },
  { en: 'Sathya Narayana Pooja', ta: 'சத்ய நாராயண பூஜை', query: 'சத்ய நாராயண', url: '/sathya-narayana-pooja' },
  { en: 'Upanayanam', ta: 'உபநயனம்', query: 'உபநயனம்', url: '/vaideekam/upanayanam' },
  { en: 'Prayogams', ta: 'பிரயோகங்கள்', query: 'பிரயோகம்', url: '/vaidhikam/prayogams' },
  { en: 'Shradhdha Services', ta: 'ச்ராத்த சேவை', query: 'ச்ராத்தம்', url: '/religious-services/shradhdha-service' },
  { en: 'Live Panchangam', ta: 'இன்றைய பஞ்சாங்கம்', query: 'பஞ்சாங்கம்', url: '/panchangam/calendar' }
];

const DIRECT_NAV_MAP = {
  // Upakarma & Bodhayana
  'உபாகர்மா': '/vaidhikam/prayogams', 'போதாயன': '/qa?q=போதாயன', 'போதாயன உபாகர்மா': '/vaidhikam/prayogams',
  'ஆவணி அவிட்டம்': '/vaidhikam/prayogams', 'upakarma': '/vaidhikam/prayogams', 'bodhayana': '/qa?q=bodhayana',
  'avani avittam': '/vaidhikam/prayogams', 'காயத்ரி ஜபம்': '/vaidhikam/prayogams',
  // Karmangalin Thathuvangal
  'கர்மங்களின் தத்துவங்கள்': '/karmangalin-thathuvangal', 'கர்மங்கள்': '/karmangalin-thathuvangal', 'தத்துவங்கள்': '/karmangalin-thathuvangal',
  'karmakkalin tattuvangal': '/karmangalin-thathuvangal', 'karmakkalin': '/karmangalin-thathuvangal', 'tattuvangal': '/karmangalin-thathuvangal',
  'karmangalin thathuvangal': '/karmangalin-thathuvangal', 'karmangalin': '/karmangalin-thathuvangal', 'thathuvangal': '/karmangalin-thathuvangal',
  'karma': '/karmangalin-thathuvangal', 'thathuvam': '/karmangalin-thathuvangal', 'tattvam': '/karmangalin-thathuvangal',

  // Panchangam & Calendar
  'பஞ்சாங்கம்': '/panchangam/calendar', 'இன்றைய பஞ்சாங்கம்': '/panchangam/calendar',
  'காலண்டர்': '/panchangam/calendar', 'மாத காட்டி': '/panchangam/monthly', 'மாத பஞ்சாங்கம்': '/panchangam/monthly',
  'panchangam': '/panchangam/calendar', 'calendar': '/panchangam/calendar',
  
  // Divya Desams
  'திவ்யதேசம்': '/divyadesams', '108 திவ்யதேசங்கள்': '/divyadesams', 'divyadesam': '/divyadesams', 'divya desam': '/divyadesams',
  'திருவரங்கம்': '/divyadesams', 'ஸ்ரீரங்கம்': '/divyadesams', 'காஞ்சிபுரம்': '/divyadesams', 'திருமலை': '/divyadesams',
  
  // Vaidhikam & Prayogams
  'பிரயோகம்': '/vaidhikam/prayogams', 'பிரயோகங்கள்': '/vaidhikam/prayogams', 'prayogam': '/vaidhikam/prayogams', 'prayogams': '/vaidhikam/prayogams',
  'ஸாமம்': '/vaidhikam/prayogams', 'யஜுர்': '/vaidhikam/prayogams', 'உதகசாந்தி': '/vaidhikam/prayogams', 'அங்குரார்ப்பணம்': '/vaidhikam/prayogams',
  'உபநயனம்': '/vaideekam/upanayanam', 'upanayanam': '/vaideekam/upanayanam', 'பூணூல்': '/vaideekam/upanayanam',
  'விவாஹம்': '/vaideekam/vivaaham', 'vivaaham': '/vaideekam/vivaaham', 'திருமணம்': '/vaideekam/vivaaham',
  'சத்ய நாராயண': '/sathya-narayana-pooja', 'sathya narayana': '/sathya-narayana-pooja',
  'ச்ராத்தம்': '/religious-services/shradhdha-service', 'ஸ்ராத்தம்': '/religious-services/shradhdha-service', 'shradhdha': '/religious-services/shradhdha-service',
  
  // Sastram & Asoucham
  'தர்ம சாஸ்திரம்': '/dharma-sastram', 'dharma sastram': '/dharma-sastram', 'சாஸ்திரம்': '/dharma-sastram',
  'ஆசௌசம்': '/vaideekam/asoucham', 'தீட்டு': '/vaideekam/asoucham', 'ஜனன மரண தீட்டு': '/vaideekam/asoucham',
  'asoucham': '/vaideekam/asoucham', 'theetu': '/vaideekam/asoucham', 'thittu': '/vaideekam/asoucham',
  'ப்ராசீன ஆசாரம்': '/pracheena-qa', 'pracheena': '/pracheena-qa',
  'கேள்வி பதில்': '/qa', 'qa': '/qa',
  'வலைப்பதிவு': '/blog', 'blog': '/blog'
};

const LOCAL_SEARCH_INDEX = [
  {
    title: '🕉️ உபாகர்மா பிரயோகம் & சாஸ்திர விதிகள் (Upakarma & Avani Avittam)',
    subtitle: 'யஜுர், ரிக், ஸாம, மற்றும் போதாயன உபாகர்மா, காண்டரிஷி தர்ப்பணம், பூணூல் மாற்றும் மந்திரங்கள் & காயத்ரி ஜபம்',
    url: '/vaidhikam/prayogams',
    category: 'vaidhikam',
    keywords: [
      'உபாகர்மா', 'போதாயன', 'போதாயன உபாகர்மா', 'போதாயன அமாவாசை', 'போதாயன இஷ்டி', 'போதாயன சூத்திரம்',
      'ஆவணி அவிட்டம்', 'upakarma', 'upakarmam', 'bodhayana', 'bodayana', 'bodhayana upakarma',
      'காண்டரிஷி தர்ப்பணம்', 'பூணூல் மாற்றுதல்', 'காயத்ரி ஜபம்', 'யஜுர் உபாகர்மா', 'ரிக் உபாகர்மா', 'ஸாம உபாகர்மா'
    ]
  },
  {
    title: '❓ போதாயன ஆசாரங்கள் & சாஸ்திர ஐயங்கள் (Bodhayana QA & Sastram)',
    subtitle: 'போதாயன அமாவாசை, போதாயன இஷ்டி மற்றும் போதாயன சூத்ர முறைப்படியான வைதீக வினா-விடைகள்',
    url: '/qa?q=போதாயன',
    category: 'sastram',
    keywords: ['போதாயன', 'போதாயன அமாவாசை', 'போதாயன இஷ்டி', 'bodhayana', 'bodayana', 'போதாயனார்', 'போதாயன சூத்ரம்']
  },
  {
    title: '📖 வைதீக கர்மங்களின் தத்துவங்கள் (Karmangalin Thathuvangal)',
    subtitle: 'வைதீக கர்மங்களின் சாஸ்திர தத்துவங்கள், விதிகள் & 40+ சடங்கு முறைகள் கைநூல்',
    url: '/karmangalin-thathuvangal',
    category: 'sastram',
    keywords: [
      'கர்மங்களின் தத்துவங்கள்', 'கர்மங்கள்', 'தத்துவங்கள்', 'கர்மங்களின்', 'தத்துவம்',
      'karmakkalin tattuvangal', 'karmakkalin', 'tattuvangal', 'tattuvam',
      'karmangalin thathuvangal', 'karmangalin', 'thathuvangal', 'thathuvam',
      'karma', 'tatva', 'tattvam', 'karmangalin-thathuvangal'
    ]
  },
  {
    title: 'ஆசௌசம் - ஜனன மரண தீட்டு விபரம் & கணிப்பான் (Theetu Calculator)',
    subtitle: '10 நாள் பங்காளிகள், 3 நாள் ஸமானோதகர்கள், பக்ஷிணீ 1.5 நாள், கர்ப்பச்சிதைவு மற்றும் ஆசௌச தர்ம சாஸ்திர துல்லிய கணிப்பான்',
    url: '/vaideekam/asoucham',
    category: 'sastram',
    keywords: ['தீட்டு', 'ஆசௌசம்', 'ஜனன மரண தீட்டு', 'தீட்டு விபரம்', 'பிறப்பு தீட்டு', 'இறப்பு தீட்டு', 'theetu', 'thittu', 'thiitu', 'teetu', 'dheetu', 'dhitu', 'theetoo', 'theettu', 'asoucham', 'asaucam', 'ஜனன', 'மரண']
  },
  {
    title: '108 திவ்யதேசங்கள் (108 Divya Desams)',
    subtitle: '108 வைணவ திவ்யதேச ஆலயங்களின் முழு விபரம், வரலாறு மற்றும் புகைப்படங்கள்',
    url: '/divyadesams',
    category: 'divyadesam',
    keywords: ['108', 'divyadesam', 'divya desam', 'திவ்யதேசம்', 'திவ்யதேசங்கள்', 'திருவரங்கம்', 'ஸ்ரீரங்கம்', 'காஞ்சிபுரம்', 'திருமலை', 'திருப்பதி', 'ஆலயம்', 'கோயில்']
  },
  {
    title: '📜 வைதீக பிரயோகங்கள் (Prayogams)',
    subtitle: 'ஸாமம் & யஜுர் வேத பூர்வ மற்றும் அபர காரிய பிரயோகங்கள் (சஸ்வர தேவநாகரி + தமிழ் உரை)',
    url: '/vaidhikam/prayogams',
    category: 'vaidhikam',
    keywords: ['பிரயோகம்', 'பிரயோகங்கள்', 'prayogam', 'prayogams', 'ஸாமம்', 'யஜுர்', 'பூர்வம்', 'அபரம்', 'உதகசாந்தி', 'அங்குரார்ப்பணம்', 'காப்புக்கட்டு', 'நாந்தீசிரார்த்தம்', 'ஜாதகர்மா', 'நாமகரணம்', 'அன்னப்ராசனம்', 'சௌளகர்மா', 'உபநயனம்', 'பாலாஸ', 'விவாஹம்', 'ஔபாஸனம்', 'கிருஹப்பிரவேசம்', 'ஸ்தாலீபாகம்']
  },
  {
    title: 'சத்ய நாராயண பூஜை (Sathya Narayana Pooja)',
    subtitle: 'ஸ்ரீ சத்ய நாராயண விரத கதை, பூஜை முறைகள் மற்றும் ஸ்லோகங்கள்',
    url: '/sathya-narayana-pooja',
    category: 'vaidhikam',
    keywords: ['சத்ய', 'நாராயண', 'பூஜை', 'sathya', 'narayana', 'pooja', 'விரதம்', 'கதை']
  },
  {
    title: '⭐ வைதீக சேவைகள் - 23 கர்மாக்கள் (Vaidhika Services)',
    subtitle: '23 வைதீக கர்மாக்களின் விவரங்கள், குறைந்தபட்ச சம்பாவனை மற்றும் முன்பதிவு',
    url: '/vaidhika-services',
    category: 'vaidhikam',
    keywords: ['வைதீக சேவைகள்', 'vaidhika services', '23 கர்மாக்கள்', 'சம்பாவனை', 'முன்பதிவு', 'புரோகிதர்']
  },
  {
    title: 'உபநயனம் (Upanayanam - பூணூல் அணிவித்தல்)',
    subtitle: 'உபநயனம் செய்ய வேண்டிய வயது, விதிமுறைகள் மற்றும் சடங்கு விளக்கம்',
    url: '/vaideekam/upanayanam',
    category: 'vaidhikam',
    keywords: ['உபநயனம்', 'upanayanam', 'பூணூல்', 'பிரம்மோபதேசம்', 'காயத்ரி']
  },
  {
    title: 'விவாஹம் (Vivaaham - திருமணம்)',
    subtitle: 'வைதீக திருமணச் சடங்குகள், மாங்கல்ய தாரணம் மற்றும் மாங்கல்ய மாலைகள்',
    url: '/vaideekam/vivaaham',
    category: 'vaidhikam',
    keywords: ['விவாஹம்', 'vivaaham', 'திருமணம்', 'கல்யாணம்', 'மாங்கல்யம்']
  },
  {
    title: 'ஸ்ராத்த சேவை & ச்ராத்த காண்டம் (Shradhdha Services)',
    subtitle: 'ஸ்ராத்த திதி கணக்கீடு, தீட்டு விதிகள் மற்றும் ச்ராத்த சேவை முன்பதிவு',
    url: '/religious-services/shradhdha-service',
    category: 'vaidhikam',
    keywords: ['ச்ராத்தம்', 'ஸ்ராத்தம்', 'shradhdham', 'shradha', 'திதி', 'தீட்டு', 'தர்ப்பணம்', 'அபரம்']
  },
  {
    title: 'இன்றைய பஞ்சாங்கம் (Live Panchangam)',
    subtitle: 'நாளைய மற்றும் இன்றைய திதி, வார, நட்சத்திர, யோக, கரண விவரங்கள்',
    url: '/panchangam/calendar',
    category: 'panchangam',
    keywords: ['பஞ்சாங்கம்', 'panchangam', 'இன்றைய', 'திதி', 'நட்சத்திரம்', 'காலண்டர்', 'calendar']
  },
  {
    title: 'கௌரி பஞ்சாங்கம் (Gowri Panchangam)',
    subtitle: 'நல்ல நேரம், சுப காலம் மற்றும் கெட்ட நேரங்களை அறியும் கௌரி பஞ்சாங்கம்',
    url: '/panchangam/gowri-panchangam',
    category: 'panchangam',
    keywords: ['கௌரி', 'gowri', 'கௌரி பஞ்சாங்கம்', 'நல்ல நேரம்', 'சுப நேரம்']
  },
  {
    title: 'சுப நாட்கள் & முகூர்த்தங்கள் (Good Days & Muhurthams)',
    subtitle: 'திருமணம், உபநயனம், க்ருஹப்ரவேசத்திற்கான சுப முகூர்த்த நாட்கள்',
    url: '/panchangam/good-days',
    category: 'panchangam',
    keywords: ['முகூர்த்தம்', 'muhurtham', 'சுப நாட்கள்', 'நல்ல நாள்', 'முகூர்த்தங்கள்']
  },
  {
    title: 'ஹோரை (Horai) & நாள்தோஷம்',
    subtitle: 'சுப ஹோரைகள் மற்றும் தினசரி நாள்தோஷக் கணக்கீடு',
    url: '/panchangam/horai',
    category: 'panchangam',
    keywords: ['ஹோரை', 'horai', 'தோஷம்', 'நாள்தோஷம்']
  },
  {
    title: 'பொது சங்கல்பம் (General Sankalpam)',
    subtitle: 'தினசரி மற்றும் சுப கார்யங்களுக்கான பொது சங்கல்ப மந்திரங்கள்',
    url: '/panchangam/gen-sankalpam',
    category: 'panchangam',
    keywords: ['சங்கல்பம்', 'sankalpam', 'பொது சங்கல்பம்', 'மந்திரம்']
  },
  {
    title: '📖 தர்ம சாஸ்திரம் (Dharma Sastram - 701 Pages)',
    subtitle: '701 பக்கங்கள் கொண்ட தர்ம சாஸ்திர விதிகள், ஆசாரங்கள் மற்றும் விளக்கங்கள்',
    url: '/dharma-sastram',
    category: 'sastram',
    keywords: ['தர்ம சாஸ்திரம்', 'dharma sastram', 'சாஸ்திரம்', 'ஆசாரங்கள்', 'தர்மம்', '701']
  },
  {
    title: '🆕 ப்ராசீன ஆசாரம் Q&A (Pracheena QA)',
    subtitle: 'பழங்கால ஆசாரங்கள், ஐயங்கள் மற்றும் சாஸ்திரக் கேள்விகளுக்கான விடைகள்',
    url: '/pracheena-qa',
    category: 'sastram',
    keywords: ['ப்ராசீன', 'ஆசாரம்', 'கேள்வி', 'பதில்', 'qa', 'pracheena']
  },
  {
    title: 'கேள்வி - பதில் மன்றம் (Q&A Forum)',
    subtitle: 'வைதீக சந்தேகங்களைக் கேட்டுத் தெளிவடையும் கேள்வி பதில் பகுதி',
    url: '/qa',
    category: 'blog',
    keywords: ['கேள்வி பதில்', 'forum', 'சந்தேகம்', 'விடை']
  },
  {
    title: 'வலைப்பதிவுகள் (Blog & Articles)',
    subtitle: 'ஆன்மீகம், வைதீகம் மற்றும் பழக்க வழக்கங்கள் பற்றிய விரிவான கட்டுரைகள்',
    url: '/blog',
    category: 'blog',
    keywords: ['வலைப்பதிவு', 'blog', 'கட்டுரைகள்', 'articles']
  }
];

const SearchModal = ({ isOpen, onClose, language = 'ta' }) => {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [activeTab, setActiveTab] = useState('all');
  const [isSearching, setIsSearching] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const inputRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => inputRef.current?.focus(), 100);
    } else {
      setQuery('');
      setResults([]);
      setHasSearched(false);
    }
  }, [isOpen]);

  const handleSearch = async (searchTerm) => {
    const termToSearch = (searchTerm !== undefined ? searchTerm : query).trim();
    if (!termToSearch) return;

    setActiveTab('all');
    setIsSearching(true);
    setHasSearched(true);
    const qLower = termToSearch.toLowerCase();

    // 1. Instant Client-Side Index Search (Full match + Word Token Split Match)
    const tokens = qLower.split(/\s+/).filter(t => t.length >= 2);
    const localMatches = LOCAL_SEARCH_INDEX.filter((item) => {
      const titleLower = item.title.toLowerCase();
      const subLower = item.subtitle.toLowerCase();
      const kwList = item.keywords.map(k => k.toLowerCase());
      
      const fullMatch = titleLower.includes(qLower) || subLower.includes(qLower) || kwList.some(k => k.includes(qLower) || qLower.includes(k));
      const tokenMatch = tokens.length > 0 && tokens.some(tok => titleLower.includes(tok) || subLower.includes(tok) || kwList.some(k => k.includes(tok)));
      return fullMatch || tokenMatch;
    });

    let mergedResults = [...localMatches];

    // 2. Query Backend API (with 2.5s timeout so spinner never freezes)
    try {
      const response = await axios.post(
        `${API}/search`,
        { term: termToSearch, user_name: 'Guest' },
        { timeout: 2500 }
      );
      const apiResults = response.data.results || [];
      apiResults.forEach((apiRes) => {
        if (!mergedResults.some((m) => m.url === apiRes.url || m.slug === apiRes.slug)) {
          mergedResults.push(apiRes);
        }
      });
    } catch (error) {
      console.warn('Backend search API timeout/offline, using local matches:', error.message);
    } finally {
      setResults(mergedResults);
      setIsSearching(false);
    }
  };

  const navigateToChip = (chip) => {
    onClose();
    if (chip.url) {
      navigate(chip.url);
    } else {
      const directUrl = DIRECT_NAV_MAP[chip.query] || DIRECT_NAV_MAP[chip.ta] || DIRECT_NAV_MAP[chip.en.toLowerCase()];
      if (directUrl) {
        navigate(directUrl);
      } else {
        setQuery(chip.query);
        handleSearch(chip.query);
      }
    }
  };

  const openGoogleSearch = () => {
    const q = encodeURIComponent(`site:ahobilam.com ${query}`);
    window.open(`https://www.google.com/search?q=${q}`, '_blank');
  };

  if (!isOpen) return null;

  const categoryMatches = (activeTab === 'all') 
    ? results 
    : results.filter(r => r.category === activeTab);

  return (
    <div style={{ backgroundColor: 'rgba(26, 35, 126, 0.75)' }} className="fixed inset-0 z-50 flex items-center justify-center p-3 backdrop-blur-sm font-sans">
      <div className="bg-[#FAF6EE] w-full max-w-2xl max-h-[85vh] rounded-xl shadow-2xl border-2 border-[#D4AF37] overflow-hidden flex flex-col">
        
        {/* Modal Header */}
        <div className="bg-gradient-to-r from-[#1A237E] to-[#283593] text-amber-100 p-4 md:p-5 flex items-center justify-between border-b-4 border-[#D4AF37]">
          <div className="flex items-center space-x-3">
            <span className="text-2xl">🔍</span>
            <div>
              <h2 className="text-lg md:text-xl font-bold text-amber-200">
                {language === 'en' ? 'Universal Site Search' : 'அஹோபிலம் பிரபஞ்சத் தேடல்'}
              </h2>
              <p className="text-xs text-amber-100/80">
                Search 108 Divya Desams, Karmas, Prayogams, Sastram & Panchangam
              </p>
            </div>
          </div>
          
          <button
            onClick={onClose}
            className="w-9 h-9 flex items-center justify-center bg-amber-500/20 hover:bg-amber-500/40 text-amber-100 rounded-full font-bold text-lg transition-colors"
            title="Close"
          >
            ✕
          </button>
        </div>

        {/* Input Bar */}
        <div className="p-4 bg-white border-b border-amber-200">
          <form onSubmit={(e) => { e.preventDefault(); handleSearch(); }} className="flex items-center space-x-2">
            <div className="relative flex-1">
              <input
                ref={inputRef}
                type="text"
                value={query}
                onChange={(e) => {
                  setQuery(e.target.value);
                  if (e.target.value.trim().length > 1) {
                    handleSearch(e.target.value);
                  }
                }}
                placeholder={language === 'en' ? "Type to search (e.g., திவ்யதேசம், தீட்டு, பஞ்சாங்கம்)..." : "தேட விழைவதை உள்ளிடுக (எ.கா. தீட்டு, உபநயனம்)..."}
                className="w-full pl-10 pr-4 py-3 bg-[#FAF6EE] border-2 border-[#D4AF37] rounded-xl text-[#1A237E] font-semibold text-base focus:outline-none focus:bg-white"
              />
              <span className="absolute left-3 top-3.5 text-lg">🔍</span>
            </div>
            
            <button
              type="submit"
              disabled={isSearching}
              className="px-5 py-3 bg-[#CC6600] hover:bg-[#E65100] text-white font-bold rounded-xl shadow-md transition-colors"
            >
              {isSearching ? '⏳ ...' : 'தேடுக'}
            </button>

            <button
              type="button"
              onClick={openGoogleSearch}
              className="px-4 py-3 bg-[#1A237E] hover:bg-[#283593] text-amber-100 font-bold rounded-xl shadow-md transition-colors flex items-center gap-1.5 text-xs md:text-sm"
              title="Search Google Custom Search Engine"
            >
              <span>🌐</span>
              <span className="hidden sm:inline">Google Search</span>
            </button>
          </form>

          {/* Quick Topic Chips */}
          <div className="flex items-center space-x-2 overflow-x-auto pt-3 pb-1 text-xs">
            <span className="font-bold text-[#CC6600] shrink-0">🔥 Quick Topics:</span>
            {POPULAR_SEARCHES.map((chip, idx) => (
              <button
                key={idx}
                onClick={() => navigateToChip(chip)}
                className="shrink-0 px-3 py-1 bg-amber-100/80 hover:bg-[#1A237E] hover:text-amber-100 text-[#1A237E] font-medium rounded-full border border-amber-300 transition-all"
              >
                {language === 'en' ? chip.en : chip.ta}
              </button>
            ))}
          </div>
        </div>

        {/* Filter Tabs */}
        {hasSearched && (
          <div className="flex border-b border-amber-200 bg-[#F5EDDA] px-4 pt-2 space-x-2 text-xs font-bold overflow-x-auto">
            {['all', 'divyadesam', 'vaidhikam', 'sastram', 'panchangam', 'blog'].map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`px-4 py-2 rounded-t-lg transition-colors ${
                  activeTab === tab
                    ? 'bg-white text-[#1A237E] border-t-2 border-x border-[#D4AF37]'
                    : 'text-gray-600 hover:text-[#CC6600]'
                }`}
              >
                {tab === 'all' ? 'All Results' : tab.charAt(0).toUpperCase() + tab.slice(1)}
              </button>
            ))}
          </div>
        )}

        {/* Results Container */}
        <div className="p-4 md:p-6 overflow-y-auto flex-1 bg-white">
          {isSearching ? (
            <div className="py-12 text-center text-amber-900 font-medium">
              <div className="inline-block w-8 h-8 border-4 border-[#CC6600] border-t-transparent rounded-full animate-spin mb-3"></div>
              <p>Searching across entire Ahobilam portal...</p>
            </div>
          ) : hasSearched ? (
            categoryMatches.length > 0 ? (
              <div className="space-y-3">
                {categoryMatches.map((res, idx) => (
                  <div
                    key={idx}
                    onClick={() => {
                      onClose();
                      navigate(res.url || `/${res.slug}`);
                    }}
                    className="p-4 bg-[#FAF6EE] hover:bg-amber-50 rounded-xl border border-amber-200 hover:border-[#CC6600] cursor-pointer transition-all shadow-2xs group"
                  >
                    <div className="flex items-center justify-between mb-1">
                      <span className="text-xs uppercase font-bold text-[#CC6600] bg-amber-100 px-2 py-0.5 rounded border border-amber-300">
                        {res.category || 'page'}
                      </span>
                      <span className="text-xs text-[#1A237E] font-medium group-hover:underline">திறக்க கிளிக் செய்க ➔</span>
                    </div>
                    <h3 className="text-base font-bold text-[#1A237E] group-hover:text-[#CC6600] transition-colors">
                      {res.title}
                    </h3>
                    <p className="text-xs md:text-sm text-gray-700 mt-1 leading-relaxed">
                      {res.subtitle || res.snippet}
                    </p>
                  </div>
                ))}
              </div>
            ) : (
              <div className="py-8 text-center bg-amber-50/50 rounded-xl border border-amber-200 p-6">
                <span className="text-3xl block mb-2">🔍</span>
                <h4 className="text-base font-bold text-[#1A237E] mb-1">No direct matches found for "{query}"</h4>
                <p className="text-xs text-amber-900 mb-4">
                  You can search Google's complete indexed pages for ahobilam.com or request content from admin.
                </p>
                <button
                  onClick={openGoogleSearch}
                  className="px-5 py-2.5 bg-blue-600 hover:bg-blue-700 text-white font-bold rounded-xl text-xs shadow-md transition-colors inline-flex items-center gap-2"
                >
                  <span>🌐</span>
                  <span>Search site on Google Search</span>
                </button>
              </div>
            )
          ) : (
            <div className="py-12 text-center text-gray-500 text-sm">
              <span className="text-4xl block mb-2">🪔</span>
              <p className="font-medium text-[#1A237E]">Type above or select a topic to search instantly.</p>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="bg-[#FAF6EE] p-3 border-t border-amber-200 text-center text-xs text-amber-900 font-medium">
          Ahobilam Universal Portal Index • Ahobilam.com
        </div>
      </div>
    </div>
  );
};

export default SearchModal;
